export default `
§ sidebar.switch.team: 팀
§ sidebar.switch.person: 직원
§ sidebar.buttons.settings: 설정
§ sidebar.buttons.print: 인쇄
§ sidebar.buttons.share: 그것을 공유
§ sidebar.buttons.logout: 나가
§ sidebar.filters.all: 항상
§ sidebar.filters.year: 년
§ sidebar.filters.halfYear: 반년
§ sidebar.filters.month: 월
§ sidebar.filters.week: 주
§ sidebar.team.total: 일반 정보
§ sidebar.team.scope: 특징
§ sidebar.team.author: 직원
§ sidebar.team.type: 작업 유형
§ sidebar.team.pr: 코드 삽입
§ sidebar.team.day: 낮에
§ sidebar.team.week: 주별
§ sidebar.team.month: 월별
§ sidebar.team.files: 파일
§ sidebar.team.removedFiles: 삭제 된 파일
§ sidebar.team.extension: 파일 형식
§ sidebar.team.tasks: 작업 목록
§ sidebar.team.release: 발매 목록
§ sidebar.team.hours: 일정
§ sidebar.team.commits: 모든 댓글
§ sidebar.team.changes: 모든 변경 사항
§ sidebar.team.words: 인기있는 단어
§ sidebar.team.building: 퀴즈
§ sidebar.team.refactor: 리팩토링
§ sidebar.team.company: 회사
§ sidebar.team.country: 위치
§ sidebar.team.settings: 설정
§ sidebar.person.total: 일반 정보
§ sidebar.person.money: 작업 비용
§ sidebar.person.speed: 속도
§ sidebar.person.day: 낮에
§ sidebar.person.week: 주별
§ sidebar.person.month: 월별
§ sidebar.person.tasks: 작업 목록
§ sidebar.person.hours: 일정
§ sidebar.person.commits: 모든 커밋
§ sidebar.person.changes: 모든 변경 사항
§ sidebar.person.words: 인기있는 단어
§ sidebar.person.settings: 설정
`;
